<template>
  <v-card
    class="ma-0"
    width="100%"
    style="height: auto"
    elevation="2"
  >
    <v-app-bar
      flat
      class="my-0 mb-6 py-1 px-2"
      dense
      height="30"
    >
      <v-toolbar-title class="mt-4 me-4">{{ $t('currencyList') }}</v-toolbar-title>
      <div
        v-if="!isMobile && !isTablet"
        style="width: 230px;"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('remove') }}
        </p>
        <v-icon>
          mdi-trash-can-outline
        </v-icon>
      </v-btn>
      <v-menu
        v-if="isMobile || isTablet"
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important;padding: 0 !important;"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon>
              mdi-dots-vertical
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="printDialog = true"
          >
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item
            v-if="(isMobile || isTablet) && currencyCount > 1"
            link
            @click="goTo('currency')"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('newCurrency')" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('filter') }}
        </p>
        <v-icon>
          mdi-filter-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4  ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('print') }}
        </p>
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && currencyCount > 1 && !isTablet"
        outlined
        @click="goTo('currency')"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t('newCurrency') }}
        </p>
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row
      v-if="isMobile || isTablet"
      class="mx-0"
    >
      <v-col
        class="mb-4 px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      id="print"
      cols="12"
      class="px-2 pt-0"
    >
      <v-data-table
        v-if="headers"
        :height="(isMobile || isTablet || mobileShow ? 323 : tableHeight)"
        fixed-header
        v-model="selected"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3;border-radius: 6px;"
        :footer-props="{
          showFirstLastPage: (!mobileShow ? true : false),
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                link
                v-clipboard:copy="$baseURL + '/pay/cash/edit/' + item.id"
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <!--<v-list-item @click="$refs.logRef.openDialog(item.id, type, null)">
                <v-list-item-icon>
                  <v-icon>mdi-history</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('history')" />
              </v-list-item>-->
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                link
                :disabled="(item.main == 'yes' ? true : false)"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.name="{ item }">
          {{ item.name }}
          <v-chip
            v-if="item.main == 'yes'"
            outlined
            label
            small
            color="primary"
          >
            {{$t('main')}}
          </v-chip>
        </template>
        <template v-slot:item.amount="{ item }">
          {{ $numberFormat(item.amount) }}
        </template>
        <template v-slot:item.id="{ item }">
          <a  @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.row="{ item }">
          <a  @click="edit(item)">
            {{ parseInt(items.indexOf(item))+ parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <div class="pt-1">
            <v-chip
              v-for="(tag, index) in item.tags"
              :key="index"
              :color="tag.color"
              label
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
            </v-chip>
          </div>
        </template>
        <template v-slot:item.invoice="{ item }">
          <div class="pt-1">
            <v-chip
              v-if="item.invoice"
              :color="item.invoice.color"
              label
              outlined
              small
              style="margin-left: 1px;margin-right:1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              {{item.invoice.name}}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
      </v-data-table>
    </v-col>
    <v-row />
<!--    filter dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
<!--    delete dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
<!--    print dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :headerProp="headers"
            :itemsProp="items"
            :title="$t('cashPayList')"
          />
        </v-row>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :color="snakbarColor"
      :active="snakbar"
    />
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Print from '../../components/general/Print/Index'
  export default {
    name: 'SellList',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      Print,
    },
    mixins: [General],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      selected: [],
      printDialog: false,
      currencyCount: false,
      deletDialog: false,
      filter: false,
      model: null,
      from: 1,
      taskDialog: null,
      type: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      search: null,
    }),
    computed: {
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        this.model = this.selected[0].text
        this.temp = this.selected[0].text
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      this.getItems()
    },
    beforeMount () {
      var storage = JSON.parse(localStorage.getItem('token'))
      this.currencyCount = storage.init.currencyCount.value
      this.type = this.$route.name
      if (this.$route.name === 'receiptList') {
        this.type = 'receipt'
      }
      if (this.$route.name === 'remittanceList') {
        this.type = 'remittance'
      }
      if (this.$route.name === 'useRemittanceList') {
        this.type = 'useRemittance'
      }
      if (this.$route.name === 'transferRemittanceList') {
        this.type = 'transferRemittance'
      }
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('id'),
          sortable: false,
          value: 'id',
        },
        {
          text: this.$t('name'),
          sortable: false,
          value: 'name',
        },
        {
          text: this.$t('currency-rate'),
          sortable: false,
          value: 'amount',
        },
        {
          text: this.$t('symbol'),
          sortable: true,
          value: 'symbol',
        },
        {
          text: this.$t('decimal'),
          sortable: false,
          value: 'decimal',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
        },
      ]
      if (this.input) {
        this.model = this.input
      }
    },
    mounted () {
      this.getItems()
    },
    methods: {
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'currencyEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'currency', {
          params: {
            search: app.search,
            page: app.options.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            options: app.options,
            tag: app.tag,
            status: app.sellStatus,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.from = res.from
          })
          .catch(err => {
            var error = err.response
            if (error.status === 401) {
              this.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'currency/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            app.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            app.loading = false
          })
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'currency', {
          params: {
            deleteItems: app.selected,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            app.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            app.loading = false
          })
      },
    },
  }
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
